import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-payment-confirmation',
    templateUrl: './payment-confirmation.component.html',
    styleUrls: ['./payment-confirmation.component.scss'],
    standalone: false
})
export class PaymentConfirmationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
